// This file is generated by a script and should not be modified directly.
const markdown: string = "Rayon de recherche en km, utile si une latitude et une longitude sont fournies. La valeur doit être comprise entre 0 et 200 et sera par défaut 30.\n"
export default markdown
